import { getResource } from "./axois.service.curd";

// One request per login: every page that needs the season list shares it.
let seasonListRequest = null;

/**
 * Returns the season list (SeasonData/SeasonList), fetching it only once.
 * Each call gets its own copy, so callers can safely pop() or sort it.
 * A failed request is not cached; the next call tries again.
 */
export const getSeasonList = async () => {
  if (!seasonListRequest) {
    seasonListRequest = getResource("SeasonData", "SeasonList").then((list) => {
      if (!Array.isArray(list)) seasonListRequest = null;
      return list;
    });
  }
  const list = await seasonListRequest;
  return Array.isArray(list) ? list.map((season) => ({ ...season })) : list;
};

/** Forgets the cached list (on logout, or after seasons change). */
export const clearSeasonList = () => {
  seasonListRequest = null;
};
